import type * as core from '../../../../../../../core'
import { MODEL_ID as GOAL_MODEL_ID } from '../../../../data/dimensions/outcomes/entities/goal/goal'

// NOTE: this action actually executes on the backend - it writes a real DMS
// mutation (collecting/persisting data server-side), then also opens the
// assistant slideout so the updated record is immediately visible there too.
export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      operation: 'combine',
      payload: {
        '[]': [
          {
            '{}': {
              operation: 'dms.mutate',
              payload: {
                '{}': {
                  insertion: {
                    '{}': {
                      inputs: {
                        '{}': {
                          records: {
                            '[]': [
                              {
                                '{}': {
                                  values: {
                                    '{}': {
                                      '!id': { '@$': 'goalId' },
                                      '!descr': 'Reviewed via Playground',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      modelId: GOAL_MODEL_ID,
                    },
                  },
                },
              },
            },
          },
          {
            '{}': {
              operation: 'ui.open-assistant',
              payload: {
                '{}': {
                  agentId: 'naming',
                  records: {
                    '[]': [
                      {
                        '{}': {
                          modelId: GOAL_MODEL_ID,
                          recordId: { '@$': 'goalId' },
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
}
